.input::placeholder {
  color: inherit;
}
